import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import moment from 'moment';
import { useStore } from '@store/appStore';
import Profile from '@components/Profile';
import { useAuthentication } from '@providers/AuthProvider';
import db from '@utils/db';
import { useRouter } from 'next/router';
import { GuardianWrapper, ProfilContent, ProfileLoader} from './Guardian.styled';
import GuardianNav from './GuardianNav';
import GuardianCalendar from './GuardianCalendar';
import GuardianHoliday from './GuardianHoliday';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import GuardianSick from './GuardianSick';


interface IProps { }

export const Guardian = (props: IProps) => {
  
  const { user, guardianStudents, systemSettings, selectedGuardianStudent, setSelectedGuardianStudent, filterDate, client, settings, setGuardianStudents, groups } = useStore();
  const [total, setTotal] = useState(null);
  const calendarRef = useRef(null);
  const [holidayRequests, setHolidayRequests] = useState([])
  const sickRef = useRef(null);
  const navRef = useRef(null);

  const [guardianLoading, setGuardianLoading] = useState(true)
  const [holyLoading, setHolyLoading] = useState(true)
  const [sickLoading, setSickLoading] = useState(true)
  const [calLoading, setCalLoading] = useState(true)
  const i18n = useI18n();
  const [day, setDay] = useState(null);
  const { getId, getType } = useAuthentication();
  const router = useRouter()  

  let SchoolName = ""
  let localTimeZone = ""
  if (systemSettings) {
    let s = systemSettings.find((t) => t.APP_Setting_ID === 65);
    if (s) SchoolName = s.value
    s = systemSettings.find((s) => s.APP_Setting_ID === 7);
    if (s) localTimeZone = s.value
  }

  async function getData(id, studentId) {
    setTotal(null);
    setDay(null);

    let userId = id;
    // const note = await db.GetNoteCounts4Student(studentId, client.UserName, getType());
    const totalData = await db.Student_Stat_GetTotalPercentage(userId, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE);
    const totalabsence = totalData ? totalData[0] : null;

    if (settings.USENOTFULLBLOCKPAUSE) {
      db.GetPause4Students(JSON.stringify([{ student_id: studentId }]), filterDate.from, filterDate.to).then(r => {
        if (r?.length > 0 && totalabsence) {
          //@ts-ignore
          totalabsence.secondabsence = totalabsence.secondabsence - r[0].pause_absence_length
          //@ts-ignore
          totalabsence.secondcount = totalabsence.secondcount - r[0].pause_length
          //@ts-ignore
          totalabsence.merit = true
        }
        setTotal(totalabsence);
      })
    }
    else {
      setTotal(totalabsence);
    }

    const dayData = await db.Student_Stat_GetTotalPercentageDay(userId, filterDate.from, filterDate.to, null, null, settings.USEMERIT, settings.USEPAUSE);
    setDay(dayData);
  }

  useEffect(() => {
    if (selectedGuardianStudent) getData(selectedGuardianStudent?.student_username, selectedGuardianStudent?.student_id)
  }, [selectedGuardianStudent])

  useEffect(() => {
    //let date = new Date()
    //date.setDate(date.getDate()+1);
    //setToDate(date)
    getStudents()
  }, [])

  const getStudents = async () => {
    let username = user.localAccountId
    // let username = router.pathname === "/guardian" ? "9B6519D4B81620E42D59985CCC6E049E45A1927B2FEA8E17109193E4C3ED8D1FEEDF2ADA699867D2AC5CB312873239E5E119177C3968D42FCF9CFB23CB1D3817" : user.id
    let students = []
    if (settings.DEMO !== "true" && settings.DEMO !== true) {
      students = await db.guardian_getstudents(username)
    }
    else {
      students = [
        {
          "student_id": "121846",
          "student_username": "86773",
          "student_displayname": "Ulrik Christiansen"
        },
        {
          "student_id": "124035",
          "student_username": "46710",
          "student_displayname": "Kristen Thomsen"
        },
        {
          "student_id": "59662",
          "student_username": "75167",
          "student_displayname": "Henriette Ernst"
        }
      ]
    }

    if (settings.DEMO === "true" || settings.DEMO === true) username = "394236353139443442383136323045343244353939383543434336453034"

    
    let holidayRequests = await db.GetAbsenceRequests4Parent(username, localTimeZone)

    setHolidayRequests(holidayRequests)
    setHolyLoading(false);

    for (let i = 0; i < students?.length; i++) {
      let s = students[i];
      const totalData = await db.Student_Stat_GetTotalPercentage(s.student_username, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE);
      const totalabsence = totalData ? totalData[0] : null;
      s.absence = totalabsence      
    }
    setGuardianStudents(students)
    if(!selectedGuardianStudent && students.length > 0)setSelectedGuardianStudent(students[0])
    setGuardianLoading(false)
    setHolyLoading(false);
    setCalLoading(false);
    calendarRef.current?.update()
    sickRef.current?.update()
  }

  const getTimeblockInfo = async (timeblocksIds, studentid) => {
        let timeblocks = (await db.getEventInfo(timeblocksIds, studentid)) ?? []
        timeblocks = timeblocks.map(t => {
          let starttime = t.starttime?.hours.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          }) + ":" + t.starttime?.minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })
          let endtime = t.endtime?.hours.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          }) + ":" + t.endtime?.minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })
          return {
            originalDate: t.date,
            date: moment(t.date).format("DD.MM.YYYY"),
            coursedescription: t.coursedescription,
            time: starttime + " - " + endtime,
          }
        })
        return timeblocks;
      }

  const handleAbsenceData = async (data, student, notes) => {
    let notesTemp = []

    for (let index = 0; index < notes?.length; index++) {
      const note = notes[index];
      let reservationIds = note.reservation_id?.split(',')
      if (note.reservation_id === null || reservationIds.length === 1) notesTemp.push(note)
      else {
        for (let i = 0; i < reservationIds.length; i++) {
          const rid = reservationIds[i];
          let temp = { ...note }
          temp.reservation_id = rid
          notesTemp.push(temp)
        }
      }
    }

    let d = {}
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (d[element.lessondate + "_" + element.teachername + "_" + element.absencetype]) {
        d[element.lessondate + "_" + element.teachername + "_" + element.absencetype].push(element)
      }
      else { d[element.lessondate + "_" + element.teachername + "_" + element.absencetype] = [element] }
    }

    let items = []

    for (const [key, value] of Object.entries(d)) {
      // console.log(value)
      let timeblocks = []

      //@ts-ignore
      for (let y = 0; y < value.length; y++) {
        const t = value[y];
        if (!notesTemp.some(a => a.reservation_id === t.timeblock_id)) timeblocks.push(t)
      }

      if (timeblocks.length > 0) {
        //@ts-ignore
        let o = { registertime: value[0].registertime, student_id: student.student_id, name: student.student_displayname, student_username: student.student_username, lessondate: value[0].lessondate, teachername: value[0].teachername, absencetype: value[0].absencetype, timeblocks: timeblocks.map(i => i.timeblock_id).join(',') }
        items.push(o)
      }
    }

    for (let i = 0; i < notes?.length; i++) {
      const note = notes[i];            
      let timeblockInfo = await getTimeblockInfo(note.reservation_id, student.student_id)      
      for (let t = 0; t < timeblockInfo.length; t++) {
        const timeblock = timeblockInfo[t];
        let o = { author_username: note.author_username, absence_id: note.absence_id, tag_ids: note.tag_ids, text: note.text, registertime: note.create_timestamp, student_id: student.student_id, name: student.student_displayname, student_username: student.student_username, lessondate: timeblock.originalDate, teachername: note.author_displayname, absencetype: note.absence_type, timeblocks: note.reservation_id }      
        items.push(o)
      }
      //console.log(timeblockInfo)
      //items.push(o)
    }
    return items
  } 

  const filterHolidsays = () => {
    let temp = JSON.parse(JSON.stringify(holidayRequests))
    temp = temp?.filter(a => a.student_id == selectedGuardianStudent?.student_id)
    return temp
  }

  const handleEditSick = async (requestinfo) => {
    navRef.current.handleEditSick(requestinfo)
  }

  const handleEditHoliday = async (requestinfo) => {
    navRef.current.handleEditHoliday(requestinfo)
  }

  
  return (<>
    <GuardianNav ref={navRef} updateStudents={getStudents} setSelected={setSelectedGuardianStudent} selected={selectedGuardianStudent} student={guardianStudents}  />
    
    <ProfilContent>
    {!guardianLoading?<Profile
              id={selectedGuardianStudent?.student_username}
              sisId={selectedGuardianStudent?.student_id}
              user_id={selectedGuardianStudent?.student_id}
              firstname={"firstname"}
              lastname={"Lastname"}
              lastLogin={'client.LASTLOGIN'}
              day={day}
              total={total}
              isAdmin={true}
              schoolView={true}
              guardian={true}
              guardianChildren={<>
                <GuardianCalendar ref={calendarRef} loading={calLoading} studentId={selectedGuardianStudent?.student_id} username={selectedGuardianStudent?.student_username} displayname={selectedGuardianStudent?.student_displayname} />
                <GuardianSick handleEditSick={handleEditSick} ref={sickRef} loading={sickLoading} updateStudents={getStudents} studentId={selectedGuardianStudent?.student_id} username={selectedGuardianStudent?.student_username} displayname={selectedGuardianStudent?.student_displayname} students={guardianStudents}  />
                <GuardianHoliday handleEditHoliday={handleEditHoliday} loading={holyLoading} updateStudents={getStudents} holidayRequests={filterHolidsays()} students={guardianStudents}  />
              </>}
              />
    :
      <ProfileLoader>
        <RainbowLoader />
      </ProfileLoader>
    }
    
    </ProfilContent>
  </>);
};

export default Guardian;
